__turbopack_context__.v({
  "attendeeCount": "QwVrva_attendeeCount",
  "column": "QwVrva_column",
  "container": "QwVrva_container",
  "orderDateTime": "QwVrva_orderDateTime",
  "orderIcon": "QwVrva_orderIcon",
  "orderInfo": "QwVrva_orderInfo",
  "orderName": "QwVrva_orderName",
  "upcomingOrder": "QwVrva_upcomingOrder",
  "width100": "QwVrva_width100",
  "width120": "QwVrva_width120",
  "width140": "QwVrva_width140",
  "width160": "QwVrva_width160",
  "width180": "QwVrva_width180",
  "width200": "QwVrva_width200",
  "width220": "QwVrva_width220",
  "width240": "QwVrva_width240",
});
